<template>
  <div class="page-add">
    <div class="add-title">
      编辑通知公告
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      size="small"
      :rules="rules"
      label-width="100px"
      class="form"
    >
      <el-form-item label="标题：" prop="noticeTitle">
        <el-input
          placeholder="请输入标题"
          v-model="ruleForm.noticeTitle"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="内容："
        prop="noticeContent"
        required
        :show-message="showError"
      >
        <!-- <rich-text
          :detail.sync="ruleForm.noticeContent"
          @change-con="changeCon"
          uploadUrl="notice/richText"
        ></rich-text>-->
        <weditor
          :detail.sync="ruleForm.noticeContent"
          uploadUrl="notice/richText"
          @change-con="changeCon"
        />
      </el-form-item>
      <el-form-item label="过期日期：" prop="expireTime">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          v-model="ruleForm.expireTime"
          style="width: 50%;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="是否置顶：" prop="setTop" required>
        <el-radio-group v-model="ruleForm.setTop">
          <el-radio
            v-for="(item, i) in topList"
            :key="i"
            :label="item.paramKey"
            >{{ item.paramValue }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="附件：" prop="attachmentList">
        <upload
          :limit="10"
          :path="'notice/file'"
          v-model="ruleForm.attachmentList"
        />
      </el-form-item>
      <el-form-item style="text-align: center;">
        <el-button @click="reset">重置</el-button>
        <el-button @click="goBack">返回</el-button>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import richText from "@/components/RichText/index";
import weditor from "@/components/weditor/index";
import { noticeUpdate, noticeDetail } from "@/api/notice";
import { getDataMap } from "@/api/sysParam";
import rulesFactory from "@/utils/rules";
import Upload from "@/components/upload/index";
import { setItem } from "@/utils/storage.js";
export default {
  components: {
    // richText,
    Upload,
    weditor
  },
  data() {
    return {
      ruleForm: {
        noticeTitle: "",
        noticeContent: "",
        expireTime: "",
        setTop: "0",
        attachment: "",
        attachmentList: []
      },
      showError: false,
      rules: {
        noticeTitle: [
          { required: true, message: "请输入公告标题", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50)
        ],
        noticeContent: [
          {
            required: true,
            message: "请输入公告内容"
          }
        ],
        expireTime: [
          {
            required: true,
            message: "请选择过期时间",
            trigger: ["change", "blur"]
          }
        ],
        setTop: [
          { required: true, message: "请选择是否置顶", trigger: "change" }
        ]
      },
      topList: []
    };
  },
  created() {
    this.getSysParam("IS_VALID");
    noticeDetail(this.$route.query.uuid).then(res => {
      const { data } = res;
      this.ruleForm.noticeTitle = data.noticeTitle;
      this.ruleForm.noticeContent = data.noticeContent;
      this.ruleForm.expireTime = data.expireTime;
      this.ruleForm.setTop = data.setTop.toString();
      this.ruleForm.onlineStatus = data.onlineStatus;
      this.ruleForm.attachmentList = JSON.parse(data.attachment);
    });
  },
  methods: {
    goBack() {
      this.$router.push('/notice');
    },
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (!this.ruleForm.noticeContent) {
          this.showError = true;
        }
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let params = {
              ...this.ruleForm,
              onlineStatus: 0,
              uuid: this.$route.query.uuid
            };
            params.expireTime = this.$moment(this.ruleForm.expireTime).format(
              "YYYY-MM-DD"
            );
            params.attachment = JSON.stringify(this.ruleForm.attachmentList);
            delete params.attachmentList;
            noticeUpdate(params).then(res => {
              if (!res || res.code != 0) return;
              setItem(this.REFRESH_FLAG, true);
              this.goBack();
            });
          });
        } else {
          return false;
        }
      });
    },
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (!res || res.code != 0) return;
        if (param == "IS_VALID") {
          this.topList = res.data;
        }
      });
    },
    changeCon(data) {
      this.ruleForm.noticeContent = data;
      if (!this.ruleForm.noticeContent) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.editFlag) {
          this.ruleForm.noticeContent = "";
          this.ruleForm.noticeTitle = "";
          this.ruleForm.expireTime = "";
        } else {
          this.ruleForm.noticeContent = "";
          this.$refs["ruleForm"].resetFields();
        }
      });
    }
  }
};
</script>
